var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVideo = function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.12 160H8V36h124.12l-.04 29.53c-.01.14-.77 8.69 6.68 23.59 7.94-11.9 20.12-25.62 38.76-40.26l6.47-5.09V152.7l-6.6-5.66c-18.56-15.91-30.71-30.08-38.63-41.99-7.64 15.57-6.69 25.31-6.67 25.48l.03.47v29ZM16 152h108.12v-20.81c-.19-2.17-.76-15.09 9.77-34.09-10.4-18.54-9.97-30.15-9.77-32.31V44H16v108Zm127.19-54.96c6.48 10.54 16.69 23.4 32.81 38.09V60.41C159.9 74 149.68 86.49 143.19 97.04Z",
    fill: "#3897FF"
  })));
};

export default SvgVideo;